"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var AppModule_1 = require("../core/modules/AppModule");

var PortionDTOConverter_1 = require("./conversions/PortionDTOConverter");

var PortionDTOConverterImpl_1 = require("./conversions/PortionDTOConverterImpl");

var PortionAppModule =
/*#__PURE__*/
function (_AppModule_1$AppModul) {
  _inherits(PortionAppModule, _AppModule_1$AppModul);

  function PortionAppModule() {
    var _this;

    _classCallCheck(this, PortionAppModule);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PortionAppModule).apply(this, arguments));
    /**
     * @inheritDoc
     */

    _this.name = 'portion';
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(PortionAppModule, [{
    key: "configure",
    value: function configure() {
      typescript_ioc_1.Container.bind(PortionDTOConverter_1.PortionDTOConverter).to(PortionDTOConverterImpl_1.PortionDTOConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
    }
  }]);

  return PortionAppModule;
}(AppModule_1.AppModule);

exports.PortionAppModule = PortionAppModule;